export default __webpack_public_path__ + "/dist/images/9117948.6c662fa673076f9b77fd88e205f1a1c5.png";